<template>
  <OrganisationsTable
    id="members-table"
    :expanded.sync="expanded"
    :headers="three_levels ? accred_headers : orgs_headers"
    :hide_select="hide_select"
    :inf_selector="inf_selector"
    infinity_updater
    :item_key="item_key || 'organizationUsreou'"
    :items="items"
    @expandRow="expandRow">
    <template #header_table_select>
      <slot name="header_table_select"/>
    </template>
    <template #item_table_select="{ item }">
      <slot
        :item="item"
        name="item_table_select"/>
    </template>
    <template #expanded-item="{ headers, item: group }">
      <td
        class="pa-0 expanded-table-td"
        :colspan="headers.length">
        <v-data-table
          v-if="!loading"
          calculate-widths
          class="elevation-0 expanded-table main__light_green pa-0"
          disable-pagination
          :headers="expand_headers"
          hide-default-footer
          hide-default-header
          :items="group.filtred_users && group.filtred_users.length ? group.filtred_users : group.users"
          :loading-text="$t('Tenders.Loading')"
          :no-data-text="$t('Tenders.NoData')"
          :no-results-text="$t('Tenders.NoData')"
          :show-select="!hide_select">
          <template #header>
            <thead class="v-data-table-header">
              <th
                v-for="(td, n) in expand_headers"
                :key="n"
                class="expanded-table-header-td"
                :style="`width : ${td.width}; max-width : ${td.width};  `"
                :width="td.width"/>
            </thead>
          </template>
          <template #[`item.data-table-select`]="{ item: itemSelect, count: countSelect }">
            <div class="ma-0 pa-0 d-flex justify-end">
              <slot
                :count="countSelect"
                :item="itemSelect"
                name="expand_item_select"/>
            </div>
          </template>
          <template v-slot:[`item.userConcatNameEmail`]="{ item: user }">
            <div
              class="flex">
              <UserIcon
                class="pa-0 mr-2"
                :name="user.userName || user.email "
                size="38"
                :src="user.avatar"/>
              <div class="pl-1 flex wrap">
                <div
                  v-if="user.userName"
                  class="h7-text width-100">
                  {{ user.userName }}
                </div>
                <div class="h7-text secondary__green_not_active--text width-100">
                  {{ user.email || $t('Common.NoData') }}
                </div>
              </div>
            </div>
          </template>

          <template #[`item.participationCount`]="{ item: user }">
            <span class="h7-text">{{ user.participationCount || $t('Common.NoData') }}</span>
          </template>
        </v-data-table>
      </td>
    </template>
    <template #expanded_item="{ headers, group }">
      <td
        class="pa-0 expanded-table-td"
        :colspan="headers.length">
        <OrganisationsTable
          class="expanded-table"
          :class="{'can-expand': second_expanded[group.groupId]}"
          :expanded.sync="second_expanded[group.groupId]"
          :headers="expand_headers"
          hide_header
          :hide_select="hide_select"
          :item_key="three_levels ? 'organizationId' : 'uniqId' "
          :items="getExpandItems(group)"
          @expandRow="expandRow">
          <template #header_item>
            <thead class="v-data-table-header">
              <td
                v-for="(td, n) in expand_headers"
                :key="n"
                class="expanded-table-header-td"
                :style="`width : ${td.width}; max-width : ${td.width};  `"
                :width="td.width"/>
            </thead>
          </template>
          <template #item_table_select="{ item: itemSelect, count: countSelect }">
            <div class="ma-0 pa-0 d-flex justify-end">
              <slot
                :count="countSelect"
                :item="itemSelect"
                name="expand_item_select"/>
            </div>
          </template>

          <template #expanded_item="{ headers: headersExpand, group: groupExpand }">
            <td
              class="pa-0 expanded-table-td"
              :colspan="headersExpand.length">
              <OrganisationsTable
                class="expanded-table"
                :headers="users_headers"
                hide_header
                :hide_select="hide_select"
                item_key="email"
                :items="getExpandItems(groupExpand)">
                <template #header_item>
                  <thead class="v-data-table-header">
                    <td
                      v-for="(td, n) in users_headers"
                      :key="n"
                      class="expanded-table-header-td"
                      :style="`width : ${td.width}; max-width : ${td.width};  `"
                      :width="td.width"/>
                  </thead>
                </template>
                <template #item_table_select="{ item: itemSelect, count: countSelect }">
                  <div class="ma-0 pa-0 d-flex justify-end">
                    <slot
                      :count="countSelect"
                      :item="itemSelect"
                      name="expand_item_select"/>
                  </div>
                </template>
              </OrganisationsTable>
            </td>
          </template>
        </OrganisationsTable>
      </td>
    </template>
  </OrganisationsTable>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import OrganisationsTable from 'components/tenders/OrganisationsTable.vue'

export default {
  name: 'membersTable',
  data() {
    return {
      count: 0,
      second_expanded: {},
      groups: {},
      expanded: []
    }
  },
  props: {
    items: Array,
    orgs_headers: Array,
    accred_headers: Array,
    grouped: Array,
    // expanded: Array,
    loading: Boolean,
    users_headers: [Array, Function],
    hide_select: Boolean,
    inf_selector: String,
    item_key: String,
    three_levels: Boolean,
  },
  created() {
  },
  computed: {
    expand_headers() {
      return  this.three_levels ? this.orgs_headers : this.users_headers
    },
  },
  methods: {
    createdGroup() {
      this.groups = this.$_.groupBy(this.grouped?.slice(0)?.reduce((tot, el) => {
        if (el.organisations) {
          tot.push(...el.organisations)
        }
        return tot
      }, []), 'groupId')
      Object.keys(this.groups).forEach(key => {
        this.second_expanded[key] = []
      })
    },
    expandRow(item) {
      item.expanded = !item.expanded
      this.expanded = this.items.filter(el => el.expanded)
      if (item.groupId && item.users &&  this.groups[item.groupId]) {
        this.second_expanded[item.groupId] = this.groups[item.groupId]?.filter(el => el.expanded)
      }

    },
    getExpandItems(group) {
      const result = group.users
        ? group.filtred_users?.length
          ? group.filtred_users
          : group.users
        : group.filtred_orgs?.length
          ? group.filtred_orgs
          : group.organisations

      return result
    },
    createExpandeds() {
      this.expanded = this.items.filter(el => el.expanded)
      Object.entries(this.groups).forEach(([key, items]) => {
        this.second_expanded[key] = items?.filter(el => el.expanded)
      })
    },
  },
  watch: {
    grouped: {
      immediate: true, // коллбэк будет вызван сразу же после начала наблюдения
      deep: true,	// Коллбэк будет вызываться каждый раз, когда изменяется любое из свойств наблюдаемого объекта, независимо от глубины их вложенности
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue || []) !== JSON.stringify(oldValue || [])) {
          this.createdGroup()
        }
      }
    },
    three_levels() {
      Object.keys(this.second_expanded).forEach(key => {
        this.second_expanded[key] = []
      })
      this.expanded = []

      let setExp = (arr) => {
        arr?.forEach(el => {
          el.expanded = false
          setExp(el.organisations)
        })
      }
      setExp(this.items)
    },
    items() {
      this.createExpandeds()
    }
  },
  components: {
    UserIcon,
    OrganisationsTable
  }
}
</script>
<style lang="scss">
#members-table {
  tr {
    td:last-child {
      color: var(--v-secondary__green_not_active-base) !important;
      font-weight: 500;
    }
    .v-btn:focus::before {
      opacity: 0;
    }
  }

  .v-data-table-header th.text-start {
    background-color: var(--v-main__light_green-base) !important;
  }
  // .v-data-table__wrapper {
  //   // max-height: calc(100vh - 385px);
  //   // overflow-y: auto !important;
  // }
  .v-data-table__expanded__row td {
    border: none !important;
  }

  .v-data-table-header th.text-start, .v-data-table__wrapper tbody tr td {
    padding: 10px  !important;
  }
  .v-data-table__wrapper tbody tr td {
    cursor: pointer;
  }

  .v-data-table__expanded {
    .v-data-table *:not(.s-checkbox__inner) {
      background-color: var(--v-main__light_green-base) !important;
    }
    .v-data-table .mdi-checkbox-marked,
    .v-data-table .mdi-checkbox-blank-outline {
      background-color: transparent !important;
    }
    td.expanded-table-td {
      padding: 0 !important;
      border: none !important;
      .expanded-table:not(.can-expand) td {
        cursor: default;
      }
      .expanded-table .v-data-table__wrapper {
        max-height: unset;
        overflow: auto;
      }
    }
    .expanded-table-header-td ,.v-data-table-header {
      padding: 0 !important;
      margin: 0 !important;
      height: 1px !important;
      min-height: 1px !important;
    }
  }

}
</style>
